var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"AppReviewReport my-4"},[_c('div',{staticClass:"d-flex align-center my-3",staticStyle:{"width":"400px"}}),_c('iframe',{staticStyle:{"width":"100%","height":"100vh"},attrs:{"src":_vm.iframeUrl}})])
}
var staticRenderFns = []

export { render, staticRenderFns }